







































































































































































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import ProvisioningMixin from "@/mixins/provisioningMixin";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { configurationsFilters } from "@/data/filters/provisioning";
import { configurationsSorters } from "@/data/sorters/provisioning";
import { Sorters } from "@/data/table";

// Types
import { ITableConfig, IFilter, ISorter } from "@/models/tables";
import { IProvisionProvider } from "@/models/provisioning";
import { LogoSize, LogoType } from "@/data/enums/logos";

@Component
export default class SelectProvisionConfiguration extends Mixins(
  FilteringSortingTableStore,
  ProvisioningMixin
) {
  // Props

  @Prop({ default: null })
  public selectedId!: string | null;

  @Prop({ default: "SPROVC" })
  public declare id: string;

  @Prop({ default: true })
  public declare ignoreHistory: boolean;

  @Prop({ default: () => ({}) })
  public defaultFilters!: { [key: string]: string };

  // Data

  public dataModule = DataModules.PROVISIONING_CONFIGURATIONS;
  public filters: IFilter[] = configurationsFilters;
  public guardFunctionalities = ["list_provision_configurations"];
  public isProcessing: any[] = [];
  public loading = false;
  public sorters: ISorter[] = configurationsSorters;

  public defaults: ITableConfig = {
    limit: 5,
    sort: {
      field: "name",
      direction: Sorters.ASCENDING
    }
  };

  // Life-cycle methods

  public created() {
    if (!this.isContentAvailable) return;
    this.loading = true;
    this.apiProps = {
      with: ["category", "provider.logos", "contract_product_counts"].join()
    };
    this.getCategoriesWithProviders();
    this.getData();
  }

  // Override mixin method

  public getStoreParams(params: any): Promise<any> {
    const filters = this.$_.mapKeys(
      this.defaultFilters,
      (v, key) => `filter[${key}]`
    );
    return this.$_.merge({ params: { ...filters } }, params);
  }

  // Methods

  public getProviderLogoUrl(provider: IProvisionProvider) {
    return this.$_.get(
      this.$_.find(provider.logos || [], logo => {
        if (logo.type === LogoType.ICON && logo.size === LogoSize.ONE_X)
          return true;
        return false;
      }),
      "url",
      null
    );
  }

  public refresh() {
    this.getData({ ...this.config, ignoreStored: true });
  }

  public onSelect(id) {
    this.isProcessing.push(id);
    this.$emit("select", id);
  }

  public get isContentAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
